"use client";
import NotFound from "@/components/views/list/NotFound";
import { useClientTranslation } from "@/app/i18n/client";
import {useSearchContext} from "@/lib/hooks/searchContext/searchStore";
import { useHeader } from "@/hooks/headerContext";

interface Props {
  title: string;
  searchText: string;
  showAllText: string;
}

export default function NotFoundNearbyVenuesClient(props: Props) {
  const {clearFilters} = useHeader()

  return (
    <NotFound
      title={props.title}
      searchText={props.searchText}
      showAllText={props.showAllText}
      clearFilter={clearFilters}
    />
  );
}
